export const DELETE_OPERATOR_REQUEST = "DELETE_OPERATOR_REQUEST";
export const DELETE_OPERATOR_SUCCESS = "DELETE_OPERATOR_SUCCESS";
export const DELETE_OPERATOR_FAILURE = "DELETE_OPERATOR_FAILURE";
